import basicController from "servicestack/basic.controller.properties";
import AutoQuery from "servicestack/auto-query/auto-query";
import cartConfig from "emun.cart/cart.config";
import labels from "emun.order/_labels";
import required from "emun.order/_required";
import Product from "emun.shopping/product.model";

export default class CartNewItemController {
  constructor() {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.labels = labels;
    $ctrl.config = cartConfig;
    $ctrl.required = required;
    $ctrl.vendors = new AutoQuery({
      url: "QueryVendors.json?Active=1",
      orderBy: "Label",
      autoLoad: true,
      pageSize: 200
    });
    $ctrl.categories = new AutoQuery({
      url: "QueryProducts.json?Fields=CategoryId&GroupBy=CategoryId&VendorId=" + $ctrl.product.vendorId,
      orderBy: "CategoryId",
      autoLoad: true,
      pageSize: 200
    });
  }

  submit() {
    const $ctrl = this;
    const newProduct = new Product($ctrl.product);
    newProduct.minimumOrderQty = newProduct.quantity = 1;
    newProduct.wholesalePrice = newProduct.listPrice = newProduct.retailPrice = newProduct.priceOverride = newProduct.price =
      $ctrl.product.price;
    newProduct.unlisted = true;
    newProduct.pricing = { 1: newProduct.price };
    if (newProduct.id[0] !== "*") newProduct.id = "*" + newProduct.id;
    console.info("newProduct", newProduct, $ctrl.product.category);
    $ctrl.$close(newProduct);
  }
}
